import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './wpbbsa-calculators-v2.component.scss';
var WpbbsaCalculatorsV2 = /** @class */ (function (_super) {
    tslib_1.__extends(WpbbsaCalculatorsV2, _super);
    function WpbbsaCalculatorsV2(element) {
        return _super.call(this, element) || this;
    }
    WpbbsaCalculatorsV2.prototype.init = function () { };
    WpbbsaCalculatorsV2.prototype.bindEvents = function () { };
    return WpbbsaCalculatorsV2;
}(Base));
export { WpbbsaCalculatorsV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-calculators-v2/wpbbsa-calculators-v2.component.ts
// module id = 1011
// module chunks = 0